/* ============================================================
   87C Contact Drawer — Logic
   ============================================================ */
(function () {
  'use strict';

  var drawer, panel, overlay, closeBtn;
  var openClass;
  var focusableEls, firstFocusable, lastFocusable;
  var previouslyFocused = null;

  function init() {
    drawer = document.querySelector('[data-contact-drawer]');
    if (!drawer) return;

    openClass = drawer.getAttribute('data-open-class') || 'c87-contact-drawer-open';
    panel = drawer.querySelector('[data-drawer-panel]') || drawer.querySelector('.c87-contact-drawer__panel');
    overlay = drawer.querySelector('[data-drawer-overlay]') || drawer.querySelector('.c87-contact-drawer__overlay');
    closeBtn = drawer.querySelector('[data-drawer-close]') || drawer.querySelector('.c87-contact-drawer__close');

    // Intercept contact links
    document.addEventListener('click', onLinkClick, true);

    // Close triggers
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', onKeyDown);
  }

  function onLinkClick(e) {
    var link = e.target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href') || '';

    // Match links pointing to /pages/contact or with data-action
    var isContactLink =
      link.getAttribute('data-action') === 'contact-drawer' ||
      /\/pages\/contact\b/i.test(href);

    if (!isContactLink) return;

    e.preventDefault();
    e.stopPropagation();
    open();
  }

  function open() {
    if (!drawer) return;

    previouslyFocused = document.activeElement;

    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add(openClass);

    // Cache focusable elements
    cacheFocusable();

    // Focus the close button after transition
    setTimeout(function () {
      if (closeBtn) closeBtn.focus();
    }, 100);
  }

  function close() {
    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(openClass);

    // Restore focus
    if (previouslyFocused && previouslyFocused.focus) {
      previouslyFocused.focus();
    }
  }

  function onKeyDown(e) {
    if (drawer.getAttribute('aria-hidden') !== 'false') return;

    if (e.key === 'Escape' || e.keyCode === 27) {
      close();
      return;
    }

    // Focus trap
    if (e.key === 'Tab' || e.keyCode === 9) {
      cacheFocusable();
      if (!focusableEls || focusableEls.length === 0) return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  }

  function cacheFocusable() {
    if (!panel) return;
    focusableEls = panel.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableEls.length) {
      firstFocusable = focusableEls[0];
      lastFocusable = focusableEls[focusableEls.length - 1];
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
